export default "__VITE_ASSET__D0nLz5_K__"